import "./FoodItem.css";
export default function QuantityControl({
  value,
  onIncrease,
  onDecrease,
  hideTitle = false,
  type = "default"
}) {
  return (
    <div className={`quantity-wrapper ${type}`}>
      {!hideTitle && <p className='quantity-label'>Quantity</p>}
      <div
        className={`quantity-control ${type === "addon" ? "addon-style" : ""}`}
      >
        {value === 0 ? (
          <button 
          className='circle-btn addon-initial-btn' 
          onClick={onIncrease}  
          >
            +
          </button>
        ) : (
          <div className='d-flex align-items-center gap-1'>
            <button className='circle-btn' 
            onClick={onDecrease}  
            >
              -
            </button>
            <span>{value}</span>
            <button className='circle-btn' 
            onClick={onIncrease}  
            >
              +
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
